import React, { createContext, useContext } from 'react'

const LocaleContext = createContext('en')
const useLocale = () => useContext(LocaleContext)

const LocaleProvider = ({ children, value }) => (
  <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
)

export { LocaleProvider, useLocale, LocaleContext }
